import { Content, ContentNode } from '@amzn/awscat-pattern-library-service-model';
import { getText } from '@amzn/awscat-editor';
import React, { useEffect, useState } from 'react';
import '../../../resources/styles/scss/components/ContentPageTree.css';
import { ContentPageTreeSection } from './ContentPageTreeSection';

interface ContentPagesTreeProps {
  nodeClassName: string;
  selectedNodeClassName: string;
  selectedNode?: ContentNode;
  onSelectedNodeChanged?: (selectedNode: ContentNode, depth: number) => void;
  treeStatus?: TreeStatus;
  content: Content;
  showRootNode?: boolean;
}

export enum TreeStatus {
  Default = 'Default',
  ExpandAll = 'ExpandAll',
  CollapseAll = 'CollapseAll',
}

export const ContentPagesTree = (props: ContentPagesTreeProps) => {
  // @ts-expect-error TS2345 - strict migration
  const [selectedNode, setSelectedNode] = useState<ContentNode>(props.selectedNode);
  const [treeStatus, setTreeStatus] = useState(props.treeStatus);

  useEffect(() => {
    setTreeStatus(props.treeStatus);
  }, [props.treeStatus]);

  useEffect(() => {
    // @ts-expect-error TS2345 - strict migration
    setSelectedNode(props.selectedNode);
  }, [props.selectedNode]);

  const handleSelectedNodeChanged = (n: ContentNode, depth: number) => {
    setSelectedNode(n);
    if (props.onSelectedNodeChanged) {
      props.onSelectedNodeChanged(n, depth);
    }
  };

  const selectRootNode = () => {
    handleSelectedNodeChanged(props.content.contentData, 0);
  };

  const tree = props.content.contentData.subContent.map((n) => {
    return (
      <ContentPageTreeSection
        key={n.href || n.id}
        node={n}
        selectedNode={selectedNode}
        nodeClassName={props.nodeClassName}
        selectedNodeClassName={props.selectedNodeClassName}
        onNodeSelected={handleSelectedNodeChanged}
        treeStatus={treeStatus}
        depth={0}
      />
    );
  });

  const titleClassName =
    props.content.contentData.id === props.selectedNode?.id
      ? props.selectedNodeClassName
      : props.nodeClassName;

  const rootShortTitle = props.content.contentData.shortTitle
    ? typeof props.content.contentData.shortTitle === 'string'
      ? props.content.contentData.shortTitle
      : getText(props.content.contentData.shortTitle)
    : '';

  const rootNode = props.showRootNode ? (
    <div className="tree-section">
      <div className={`${titleClassName} display-flex-row`}>
        <div className="width-100" onClick={selectRootNode}>
          {rootShortTitle || props.content.contentData.title}
        </div>
      </div>
    </div>
  ) : null;

  return (
    <div className="content-page-tree">
      {rootNode}
      {tree}
    </div>
  );
};
